export default class WallboardIncidentsData {
  constructor(data) {
    this.title = `${data.incident_name}`
    this.info = data.d_0
  }
}
